import { build } from "../../services/crudFactory";
import { Action } from "../../services/actions.factory";
import api from "../../services/api.service";
import * as messageActions from '../../store/message/message.actions';
const BASE_PATH = '/lognex/hub-integrations';

const prefix = "crudHubIntegrations";

const crud = build(false, BASE_PATH);


const newTypes = {
  SET_LOOKUP_CARRIER_VISIBLE: `${prefix}setLookupCarrierVisible`,
  SET_INITIAL_DATE_FILTER: `${prefix}setInitialDateFilter`,
  SET_FINAL_DATE_FILTER: `${prefix}setFinalDateFilter`,
  SET_NFE_NUMBER_FILTER: `${prefix}setNfeNumberFilter`,
  SET_LOOKUP_CARRIER_VISIBLE: `${prefix}setLookupCarrierVisible`,
  SET_EXPANDED_ORDERS_ROWS: `${prefix}setExpandedShipmentRows`,
  APPROVE_ORDER: `${prefix}approveOrder`,
  SET_DIALOG_APPROVE_COMPONENT_VISIBLE: `${prefix}setDialogApproveComponentVisible`,
  SET_CURRENT_APPROVE_COMPONENT_DESCRIPTION: `${prefix}setCurrentApproveComponentDescription`,
  SET_DIALOG_APPROVE_COMPONENT_TYPE: `${prefix}setDialogApproveComponentType`,
  SHOW_DIALOG_ERP_CONFIGURATION: `${prefix}showDialogErpConfiguration`,
  SHOW_DIALOG_MANUAL_IMPORT: `${prefix}showDialogManualImport`,
  SET_FULLSOFT_ENABLED: `${prefix}setFullsoftEnabled`,
  SET_PRESSIER_ENABLED: `${prefix}setPressierEnabled`,
  SET_ORDERS_TO_APPROVE: `${prefix}setOrdersToApprove`,
  ENABLE_MANUAL_MODULE: `${prefix}enableManualModule`,
  SHOW_DIALOG_ERP_MENU: `${prefix}showDialogErpMenu`,
  ENABLE_SEFAZ_MODULE: `${prefix}enableSefazModule`,
  SET_SANKHYA_ENABLED: `${prefix}setSankhyaEnabled`,
  SET_GOOGLE_ENABLED: `${prefix}setGoogleEnabled`,
  CHANGE_AUT_HANDLER: `${prefix}changeAutHandler`,
  SET_PROMOB_ENABLED: `${prefix}setPromobEnabled`,
  SET_FOCCO_ENABLED: `${prefix}setFoccoEnabled`,
  SET_TOTVS_ENABLED: `${prefix}setTotvsEnabled`,
  SHOW_DIALOG_NFE_ERROR: `${prefix}showDialogNfeError`,
  SHOW_DIALOG_CTE_ERROR: `${prefix}showDialogCteError`,
  ENABLE_API_MODULE: `${prefix}enableApiModule`,
  SET_AGILE_ENABLED: `${prefix}setAgileEnabled`,
  ENABLE_EDI_MODULE: `${prefix}enableEdiModule`,
  PASSWORD_CTE_PFX: `${prefix}passwordCtePFX`,
  SET_SAP_ENABLED: `${prefix}setSapEnabled`,
  SET_ACTIVE_INTEGRATION: `${prefix}setActiveIntegration`,
  LOAD_CONFIGURATION_CTE: `${prefix}loadConfigurationCte`,
  LOAD_CONFIGURATION_NFE: `${prefix}loadConfigurationNfe`,
  SET_CREDENTIALS: `${prefix}setCredentials`,
  SET_MESSAGE_ERROR: `${prefix}setMessageError`,

  PASSWORD_PFX: `${prefix}passwordPFX`
};

const actions = new Action(prefix, crud);

const types = Object.assign({}, actions.types, newTypes);

actions.setMessageError = (messageError) => {
  return {
    type: types.SET_MESSAGE_ERROR,
    messageError
  }
}

actions.setCredentials = (credentials) => {
  return {
    type: types.SET_CREDENTIALS,
    credentials
  }
}

actions.setLookupCarrierVisible = (visible) => {
  return {
    type: types.SET_LOOKUP_CARRIER_VISIBLE,
    visible
  }
}
actions.setInitialDateFilter = (initialDateFilter) => {
  return {
    type: types.SET_INITIAL_DATE_FILTER,
    initialDateFilter
  }
}
actions.setAutValue = (value) => {
  return {
    type: types.CHANGE_AUT_HANDLER,
    value
  }
}
actions.setFinalDateFilter = (finalDateFilter) => {
  return {
    type: types.SET_FINAL_DATE_FILTER,
    finalDateFilter
  }
}
actions.setNfeNumberFilter = (nfeNumberFilter) => {
  return {
    type: types.SET_NFE_NUMBER_FILTER,
    nfeNumberFilter
  }
}
actions.setLookupCarrierVisible = (visible) => {
  return {
    type: types.SET_LOOKUP_CARRIER_VISIBLE,
    visible,
  };
};
actions.setExpandedOrdersRows = (expandedOrders) => {
  return {
    type: types.SET_EXPANDED_ORDERS_ROWS,
    expandedOrders,
  };
}
actions.setOrdersToApprove = (approveOrder) => {
  return {
    type: types.SET_ORDERS_TO_APPROVE,
    approveOrder,
  };
}
actions.approveOrder = () => {
  return (dispatch, getState) => {
    const order = getState().auditoriaTrackingState.approveOrder;
    const description = getState().auditoriaTrackingState.currentApproveComponent.description;
    const idEmbarque = getState().auditoriaTrackingState.idEmbarque;
    const valueFreight = getState().auditoriaTrackingState.valueFreight;
    const cnpjCarrier = getState().auditoriaTrackingState.cnpjCarrier;
    const numberNFE = getState().auditoriaTrackingState.numberNFE;

    return api.post(`/api/v1${BASE_PATH}/approve`, { order, description, idEmbarque, valueFreight, cnpjCarrier, numberNFE })
      .then((response) => {
      })
  }
}
actions.downloadCSV = (filters) => {
  return (dispatch) => {
    dispatch(actions.load());
    api.post(`/api/v1${BASE_PATH}/report`)
      .then((response) => {
        const data = response.data;
        const anchor = document.createElement("a");
        anchor.href = data.presigned_url;
        anchor.target = "_blank";
        document.body.append(anchor);
        anchor.click();
        anchor.remove();
      })
      .catch((err) => {
        console.log(err);
        dispatch(actions.hideLoader());
      });
  }
}
actions.uploadPFXCte = (file) => {
  return (dispatch, getState) => {
    dispatch(actions.showLoader());

    const URL = `/api/v1${BASE_PATH}/ctesefaz/upload-pfx`;
    const passwordCtePFX = getState().crudHubIntegrationsState.passwordCtePFX;

    dispatch(actions.showLoader());
    if (file.length > 0 && passwordCtePFX != "") {

      api.uploadFiles(URL, file, null, passwordCtePFX).then((response) => {
        const { data } = response;
        dispatch(actions.findConfigurationCte());
        dispatch(actions.findConfigurationNfe());
        dispatch(actions.hideLoader());
        const messages = [
          "Configuração de NF-e realizada com sucesso."
        ];
        dispatch(
          actions.messageActions.messageShowMessages(actions.makeMessages(messages, "success"))
        );

      })
        .catch((err) => {
          if (err.response) {
            const messages = [
              err.response.data.message
            ];
            dispatch(
              actions.messageActions.messageShowMessages(actions.makeMessages(messages, "error"))
            );
          }
          dispatch(actions.findConfigurationCte());
          dispatch(actions.findConfigurationNfe());
          dispatch(actions.hideLoader());
        });

    } else {
      const messages = [
        "Certificado e senha obrigatório."
      ];
      dispatch(
        actions.messageActions.messageShowMessages(actions.makeMessages(messages, "error"))
      );
      dispatch(actions.hideLoader());
    }

  }
}

actions.uploadPFX = (file) => {
  return (dispatch, getState) => {
    dispatch(actions.showLoader());

    const URL = `/api/v1${BASE_PATH}/nfesefaz/upload-pfx`;
    const passwordNfePFX = getState().crudHubIntegrationsState.passwordNfePFX;

    dispatch(actions.showLoader());
    if (file.length > 0 && passwordNfePFX != "") {

      api.uploadFiles(URL, file, null, passwordNfePFX).then((response) => {
        const { data } = response;
        dispatch(actions.findConfigurationCte());
        dispatch(actions.findConfigurationNfe());
        dispatch(actions.hideLoader());
        const messages = [
          "Configuração de NF-e realizada com sucesso."
        ];
        dispatch(
          actions.messageActions.messageShowMessages(actions.makeMessages(messages, "success"))
        );

      })
        .catch((err) => {
          dispatch(actions.findConfigurationCte());
          dispatch(actions.findConfigurationNfe());
          dispatch(actions.hideLoader());
          if (err.response) {
            const messages = [
              err.response.data.message
            ];
            dispatch(
              actions.messageActions.messageShowMessages(actions.makeMessages(messages, "error"))
            );
          }
        });

    } else {
      const messages = [
        "Certificado e senha obrigatório."
      ];
      dispatch(
        actions.messageActions.messageShowMessages(actions.makeMessages(messages, "error"))
      );
      dispatch(actions.hideLoader());
    }

  }
}

actions.findConfigurationCte = () => {
  return (dispatch) => {
    dispatch(actions.showLoader());
    api.post(`/api/v1${BASE_PATH}/ctesefaz/configuration`)
      .then((response) => {
        const data = response.data;
        dispatch(actions.hideLoader());
        dispatch({
          type: types.LOAD_CONFIGURATION_CTE,
          logCte: data,
          async: false
        }
        )
      })
      .catch((err) => {
        dispatch(actions.hideLoader());
        dispatch({
          type: types.LOAD_CONFIGURATION_CTE,
          logCte: [],
          async: false
        }
        );
        dispatch(
          actions.messageActions.messageShowMessages(actions.makeMessages("Não foi possível carregar logs", "error"))
        );
      });
  }
}
actions.findConfigurationNfe = () => {
  return (dispatch) => {
    dispatch(actions.showLoader());
    api.post(`/api/v1${BASE_PATH}/nfesefaz/configuration`)
      .then((response) => {
        const data = response.data;
        dispatch(actions.hideLoader());
        dispatch({
          type: types.LOAD_CONFIGURATION_NFE,
          logNfe: data,
          async: false
        }
        )
      })
      .catch((err) => {
        dispatch(actions.hideLoader());
        dispatch({
          type: types.LOAD_CONFIGURATION_NFE,
          logNfe: [],
          async: false
        }
        );
        dispatch(
          actions.messageActions.messageShowMessages(actions.makeMessages("Não foi possível carregar logs", "error"))
        );
      });
  }
}

actions.passwordPFX = (password) => {
  return {
    type: types.PASSWORD_PFX,
    password
  }
}

// Dialog Approve Component
actions.setDialogApproveComponentVisible = (visible) => {
  return {
    type: types.SET_DIALOG_APPROVE_COMPONENT_VISIBLE,
    visible,
  };
}
actions.setCurrentApproveComponentDescription = (description) => {
  return {
    type: types.SET_CURRENT_APPROVE_COMPONENT_DESCRIPTION,
    description
  }
}
actions.setDialogApproveComponentType = (approvalType) => {
  return {
    type: types.SET_DIALOG_APPROVE_COMPONENT_TYPE,
    approvalType
  }
}

actions.enableSefazModule = (enable) => {
  return {
    type: types.ENABLE_SEFAZ_MODULE,
    enable
  }
}

actions.enableManualModule = (enable) => {
  return {
    type: types.ENABLE_MANUAL_MODULE,
    enable
  }
}

actions.enableApiModule = (enable) => {
  return {
    type: types.ENABLE_API_MODULE,
    enable
  }
}

actions.enableEdiModule = (enable) => {
  return {
    type: types.ENABLE_EDI_MODULE,
    enable
  }
}

actions.showDialogErpMenu = (enable) => {
  return {
    type: types.SHOW_DIALOG_ERP_MENU,
    enable
  }
}

actions.showDialogErpConfiguration = (enable, name) => {
  return {
    type: types.SHOW_DIALOG_ERP_CONFIGURATION,
    enable,
    name
  }
}

actions.showDialogNfeError = (enable) => {
  return {
    type: types.SHOW_DIALOG_NFE_ERROR,
    enable
  }
}
actions.showDialogCteError = (enable) => {
  return {
    type: types.SHOW_DIALOG_CTE_ERROR,
    enable
  }
}

actions.showDialogManualImport = (enable) => {
  return {
    type: types.SHOW_DIALOG_MANUAL_IMPORT,
    enable
  }
}

actions.setPasswordCtePFX = (password) => {
  return {
    type: types.PASSWORD_CTE_PFX,
    password
  }
}

actions.setSapEnabled = (value) => {
  return {
    type: types.SET_SAP_ENABLED,
    value
  }
}

actions.setFoccoEnabled = (value) => {
  return {
    type: types.SET_FOCCO_ENABLED,
    value
  }
}

actions.setAgileEnabled = (value) => {
  return {
    type: types.SET_AGILE_ENABLED,
    value
  }
}

actions.setFullsoftEnabled = (value) => {
  return {
    type: types.SET_FULLSOFT_ENABLED,
    value
  }
}

actions.setGoogleEnabled = (value) => {
  return {
    type: types.SET_GOOGLE_ENABLED,
    value
  }
}

actions.setPressierEnabled = (value) => {
  return {
    type: types.SET_PRESSIER_ENABLED,
    value
  }
}

actions.setPromobEnabled = (value) => {
  return {
    type: types.SET_PROMOB_ENABLED,
    value
  }
}

actions.setSankhyaEnabled = (value) => {
  return {
    type: types.SET_SANKHYA_ENABLED,
    value
  }
}

actions.setTotvsEnabled = (value) => {
  return {
    type: types.SET_TOTVS_ENABLED,
    value
  }
}

actions.setActiveIntegration = (integrationName, integrationTitle) => {
  return {
    type: types.SET_ACTIVE_INTEGRATION,
    integrationName,
    integrationTitle
  }
}

actions.generateCredentialsAPI = () => {
  return (dispatch) => {
    
    dispatch(actions.showLoader());   
     
    api.post(`/api/v1${BASE_PATH}/generate-credentials-whitelabel`)
      .then((response) => {
        if (response.data.error) {
          dispatch(actions.setMessageError(response.data.error));
          dispatch(actions.setCredentials(null));
        } else {
          const { accountId, accountKey } = response.data;
          dispatch(actions.setCredentials({ accountId, accountKey }));
          dispatch(actions.setMessageError(null));
        }
        dispatch(actions.hideLoader());
      })
      .catch((err) => {
        console.log(err);
        dispatch(actions.setCredentials(null));
        dispatch(
          actions.messageActions.messageShowMessages(
              makeMessages(["Não foi possível gerar as credenciais."], "error")
          )
        ); 
        dispatch(actions.hideLoader());
      });
  }
}

actions.getCredentialsApiWhitelabel = () => {
  return (dispatch) => {
    dispatch(actions.showLoader());
    api.post(`/api/v1${BASE_PATH}/get-credentials-whitelabel`)
      .then((response) => {
        console.log("response.data ===> ", response.data);
        if (response.data && response.data.error) {  
          dispatch(actions.setCredentials(null)); 
          dispatch(actions.setMessageError(response.data.error));
        } else {
          dispatch(actions.hideLoader());
          dispatch(actions.setMessageError(null));
          dispatch(actions.setCredentials(response.data));  
          dispatch(
            actions.messageActions.messageShowMessages(
                makeMessages(["Credenciais carregadas com sucesso."], "success")
            )
          );
        } 
      })
      .catch((err) => {
        console.log(err);
        dispatch(actions.setCredentials(null));
        dispatch(
          actions.messageActions.messageShowMessages(
              makeMessages(["Não foi possível carregar as credenciais."], "error")
          )
        ); 
        dispatch(actions.hideLoader());
      });
  }
}

function makeMessages(messages, type) {
  return messages.map(message => {
      return { sticky: true, severity: type, detail: message };
  });
};


export { types, actions };
